export default {
  PaymentsEmpty: "No payments to see yet",
  PaymentsEmptyFilterActive: "No payments found"
};
